enum ExternalAgency
{
    Guiide = 0,
    PathLines = 5,
    Aon = 6
}

export default ExternalAgency;
